__turbopack_context__.v({
  "error-msg": "_876rpG_error-msg",
  "form": "_876rpG_form",
  "form-field": "_876rpG_form-field",
  "link-card-share": "_876rpG_link-card-share",
  "share": "_876rpG_share",
  "share-btn": "_876rpG_share-btn",
  "share-buttons": "_876rpG_share-buttons",
});
